import React, { FC } from 'react'
import { FormattedDateTime } from 'transfix-ui/components/FormattedDateTime'
import { OfferedShipmentStop } from 'apps/fleet-planner/types'
import { AllowedTimezones, currentTimezone } from 'constants/AllowedTimezones'

interface IOfferAppointmentDateTime {
  stop: OfferedShipmentStop
}

export const OfferAppointmentDateTime: FC<IOfferAppointmentDateTime> = ({ stop = {} }) => {
  const { displayTimezone, startAt } = stop || {}
  // if the stop has both a startAt and an endAt, it is an appointment window

  return (
    <>
      <FormattedDateTime
        datetime={startAt || '0'}
        displayTimezone={(displayTimezone as AllowedTimezones) || currentTimezone}
        format='timeWeekdayDateAndYear'
        timeShort
        showTimezone
      />
    </>
  )
}
